import React, { useState } from 'react';

import Ads from '_components/Ads';
import ArticleCard from '_components/article-v3/ArticleCard';
import GetQuoteBanner from '_components/article-v3/GetQuoteBanner';
import BreadCrumb from '_components/BreadCrumb';
import GetQuoteCard from '_components/GetQuoteCard';
import { urlForArticleCategory } from '_utils/articles';

import MostViewedArticles from './MostViewedArticles';

const PER_PAGE = 6;

function ArticleList({ articles = [], category, title, slug, searchQuery }) {
  const [currentPage, setCurrentPage] = useState(1);
  const breadCrumbItems = category
    ? [
        { label: 'Home', url: '/' },
        { label: 'Articles', url: '/articles' },
        {
          label: category.title,
          url: urlForArticleCategory(category),
        },
        {
          label: title,
          current: true,
        },
      ]
    : [
        { label: 'Home', url: '/' },
        { label: 'Articles', url: '/articles' },
        { label: title, current: true },
      ];

  const displayArticles = articles.slice(0, currentPage * PER_PAGE);

  let level3Slug;
  if (slug) {
    level3Slug = slug.split('/').slice(-1)[0];
  }

  return (
    <main className="max-w-[1440px] mx-auto px-4 sm:px-8 xl:px-16">
      <BreadCrumb className="my-6 sm:my-8" items={breadCrumbItems} />
      <div className="text-content-primary bg-white flex flex-col lg:flex-row gap-x-8">
        <div className="max-w-[976px] flex flex-col gap-y-4 sm:gap-y-8 flex-1">
          <div className="text-lg sm:text-2xl font-bold">{title}</div>
          {displayArticles.length === 0 ? (
            <div className="text-center w-fulltext-content-secondary text-xl mt-8">
              No articles found
            </div>
          ) : null}
          {displayArticles.map((a, index) => (
            <React.Fragment key={a._id}>
              <ArticleCard article={a} />
              {index === 2 
              ? <GetQuoteBanner utmMedium={category && level3Slug ? `articles-${category.slug.current}-${level3Slug}-l3` : `articles-search`} /> 
              : null}
            </React.Fragment>
          ))}
          {displayArticles.length < articles.length && (
            <div className="mt-6 sm:mt-8">
              <button
                type="button"
                className="w-full font-bold border border-stroke-input py-1 sm:py-3 rounded text-base"
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Load more
              </button>
            </div>
          )}
        </div>

        <div className="w-full lg:w-[300px] pt-8 lg:pt-16">
          <section className="flex sm:hidden lg:block flex-col justify-center items-center">
            <div className="mt-6 md:mt-0">
              {searchQuery
              ? <Ads
                  desktop={{
                    adsId:
                      '/325540922/oneshift_web/desktop_article_search_rect_atf_01',
                    sizes: [[300, 250], 'fluid'],
                  }}
                  mobile={{
                    adsId:
                      '/325540922/oneshift_web/mobile_article_search_rect_btf_01',
                    sizes: [[300, 250], 'fluid'],
                  }}
                  divId="div-gpt-ad-article-search"
                />
              : <Ads
                  desktop={{
                    adsId:
                      '/325540922/oneshift_web/desktop_article_level3_rect_atf_01',
                    sizes: [[300, 250], 'fluid'],
                  }}
                  mobile={{
                    adsId:
                      '/325540922/oneshift_web/mobile_article_level3_rect_btf_01',
                    sizes: [[300, 250], 'fluid'],
                  }}
                  divId="div-gpt-ad-article-level3"
                />
              }
            </div>
            <GetQuoteCard utmMedium={category && level3Slug ? `articles-${category.slug.current}-${level3Slug}-l3` : `articles-search`} />
          </section>
          <MostViewedArticles />
        </div>
      </div>
    </main>
  );
}

export default ArticleList;
